import { render, staticRenderFns } from "./AuthForgotPasswordForm.vue?vue&type=template&id=1cfe9256&"
import script from "./AuthForgotPasswordForm.vue?vue&type=script&lang=js&"
export * from "./AuthForgotPasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports